/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_aec7d74f{border:0px;outline:none;width:100%}.editingInput_aec7d74f::-ms-clear{display:none}.editingContainer_aec7d74f{margin:4px}\n"}]);
export const editingInput = "editingInput_aec7d74f";
export const editingContainer = "editingContainer_aec7d74f";